/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendStandartProductConversionFieldDto } from '../../models/backend-standart-product-conversion-field-dto';

export interface SalesStandardProductConversionFieldsList$Params {
  product?: number;

  /**
   * A search term.
   */
  search?: string;
}

export function salesStandardProductConversionFieldsList(
  http: HttpClient,
  rootUrl: string,
  params?: SalesStandardProductConversionFieldsList$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<Array<BackendStandartProductConversionFieldDto>>> {
  const rb = new RequestBuilder(rootUrl, salesStandardProductConversionFieldsList.PATH, 'get');
  if (params) {
    rb.query('product', params.product, {});
    rb.query('search', params.search, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<Array<BackendStandartProductConversionFieldDto>>;
    }),
  );
}

salesStandardProductConversionFieldsList.PATH = '/api/sales/standard-product-conversion-fields/';
